import {
  CREATE_EMPRESA_INIT,
  CREATE_EMPRESA_SUCCESS,
  DELETE_EMPRESA_INIT,
  DELETE_EMPRESA_SUCCESS,
  LIST_EMPRESA_INIT,
  LIST_EMPRESA_SUCCESS,
  MODIFY_EMPRESA_INIT,
  MODIFY_EMPRESA_SUCCESS,
  EMPRESA_CLEAN_UP,
  EMPRESA_ERROR_MSG,
  ATRIBUIR_PAINEIS_EMPRESA_INIT,
  ATRIBUIR_PAINEIS_EMPRESA_SUCCESS,
  EMPRESA_CLEAN_LIST_EMPS
} from '../actionTypes';

const INIT_STATE: any = {
  loading: false,
  error: '',
  isCreated: false,
  isDeleted: false,
  isUpdated: false,
  isError: false,
  isReceived: false,
  allEmps: [],
  allStatusEmps: [],
  msg: '',
  isAssign: false
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case LIST_EMPRESA_INIT:
      return { ...state, loading: true };
    case LIST_EMPRESA_SUCCESS: {
      const { allEmps, allStatusEmps } = action.payload;
      return {
        ...state,
        allEmps,
        allStatusEmps,
        loading: false
      };
    }
    case CREATE_EMPRESA_INIT:
      return { ...state, isCreated: false };
    case CREATE_EMPRESA_SUCCESS: {
      const { msg, isCreated, empresa } = action.payload;
      return {
        ...state,
        allEmps: state.allEmps.concat(empresa),
        isCreated,
        msg
      };
    }
    case MODIFY_EMPRESA_INIT: {
      return {
        ...state,
        isUpdated: false
      };
    }
    case MODIFY_EMPRESA_SUCCESS: {
      const { msg, isUpdated, empresa } = action.payload;
      return {
        ...state,
        allEmps: state.allEmps.map((m: any) => m.id === empresa.id ? empresa : m),
        msg,
        isUpdated
      };
    }
    case DELETE_EMPRESA_INIT:
      return {
        ...state,
        isDeleted: false
      };
    case DELETE_EMPRESA_SUCCESS: {
      const { msg, empId, isDeleted } = action.payload;
      return {
        ...state,
        allEmps: state.allEmps.filter((elem: any) => elem.id !== empId),
        isDeleted,
        msg
      };
    }
    case EMPRESA_ERROR_MSG: {
      const { msg } = action.payload;
      return { ...state, loading: false, msg, isError: true };
    }
    case ATRIBUIR_PAINEIS_EMPRESA_INIT: {
      return {
        ...state,
        isAssign: false
      };
    }
    case ATRIBUIR_PAINEIS_EMPRESA_SUCCESS: {
      const { msg, isAssign } = action.payload;
      return {
        ...state,
        msg,
        isAssign
      };
    }
    case EMPRESA_CLEAN_UP: {
      return {
        ...state,
        loading: false,
        isCreated: false,
        isDeleted: false,
        isUpdated: false,
        isError: false,
        isReceived: false,
        msg: '',
        isAssign: false
      };
    }
    case EMPRESA_CLEAN_LIST_EMPS: {
      return {
        ...state,
        allEmps: []
      };
    }
    default:
      return { ...state };
  }
};
